import { useGetGalleryById } from "./galleries";
import { useGetPostById } from "./posts";

// Custom hook for conditional fetching
export const useGetContentById = (
  id: number,
  category: "posts" | "gallery"
) => {
  const postQuery = useGetPostById(id);
  const galleryQuery = useGetGalleryById(id);

  return category === "posts" ? postQuery : galleryQuery;
};
